export default class BarcodeServiceWeb {}
